import React, { useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import {useSelector } from 'react-redux';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink, useNavigate } from "react-router-dom";
import { appTheme } from "../theme/colorTheme";
import { Typography } from "@mui/material";
import useDelayUnmount from "../utils/useDelayUnmont";
import depositIcon from '../img/deposit_icon.png';
import withdrawIcon from '../img/withdraw_icon.png';
import SnackBar from "./SnackBar";
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import SnackBarAppDownload from "../components/customComponent/SnackBarAppDwonload";
import { localStorageKey } from "../constants/LocalStorageKey";
import { isMobileDeviceAndroid } from "../constants/Helper";
import constant from "../constants/Constatnt";
import androidLogo from '../img/android-icon.svg';
import { AuthContext } from "../context/AuthProvider";

const HeaderBar = (props) => {
  const navigate = useNavigate();
  const {joyTour, setJoyTour } = React.useContext(AuthContext);
  const isIntersecting = useSelector(store => store.headerIntersection.isIntersecting);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackBarMessage, setSnackBarMessage] = React.useState('');
  const [openAppDownloadSnackbar, setOpenAppDownloadSnackbar] = React.useState(true);
  const myIdData = useSelector(store => store?.app?.myIdData);
  const isAppDownloadSnackbarOpen = useSelector(store => store?.app?.isAppDownloadSnackbarOpen);
  const { wallet_balance } = useSelector(store => store?.app?.userInfo);
  const {withdraw_status, hold_withdrawal_remarks } = useSelector(store => store?.app?.withdrawalStatus);
  const showDiv = useDelayUnmount(isIntersecting,300);
  const mountedStyle = { animation: "inAnimation 450ms ease-in" };
  const unmountedStyle = {
    animation: "outAnimation 470ms ease-out",
    animationFillMode: "forwards"
  };
  const handleDrawerToggle = () => {
    props.openDrawewr();
  }
  

  useEffect(() => {
    if((!!myIdData && myIdData.length !== 0) || !!JSON.parse(localStorage.getItem(localStorageKey.ISJOYTOUROPEN))){
      setJoyTour(prvState => {
        return {...prvState, status:'CLOSED', run:false}
      })
    }else if(joyTour.status !== 'CLOSED'){
      setJoyTour(prvState => {
        return {...prvState, run:true, status:'OPEN'}
      });
    }else if(joyTour.stepIndex <= 2 && joyTour.status !== 'CLOSED'){
      setJoyTour(prvState => {
        return {...prvState, run:false}
      })
    }
  }, [joyTour.status, isIntersecting])

  return (
    <>
     <SnackBar
        setOpen={setOpenSnackbar}
        open={openSnackbar}
        message={snackBarMessage}
      />
      <AppBar position="fixed" sx={{
        maxWidth: "600px",
        bgcolor: appTheme.color0,
        color: appTheme.color1,
        boxShadow: '0px 0px 0px 0px',
        margin: "0 auto",
        left: 'auto',
        right: 'auto',
      }}>
        {
          joyTour.status === 'CLOSED' &&
          !localStorage.getItem(localStorageKey.PUSHID) && isMobileDeviceAndroid() && (openAppDownloadSnackbar &&
            localStorage.getItem(localStorageKey.ISDOWNLOADAPPSNACKBAROPEN) === null)
          && window.location.pathname === '/home' &&
          <SnackBarAppDownload setOpenAppDownloadSnackbar={setOpenAppDownloadSnackbar} />
        }
        <Toolbar>
          {
            showDiv && <div className="transitionDiv display-block-header" style={isIntersecting || joyTour.status === 'OPEN' ? mountedStyle : unmountedStyle}>
          <MenuIcon sx={{cursor:'pointer', background:'none'}} onClick={handleDrawerToggle}/>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { md: "flex" } }}>
          {  
           !localStorage.getItem(localStorageKey.PUSHID) && isMobileDeviceAndroid() && (isAppDownloadSnackbarOpen ||
            localStorage.getItem(localStorageKey.ISDOWNLOADAPPSNACKBAROPEN) !== null)
          && <Button size="small" onClick={() => {
                window.open(constant.apkUrl);
            }} sx={{
                height: '30px',
                pr:1,
                mt:{md:1},
                fontSize: 11,
                backgroundColor: appTheme.color12, color: appTheme.color0,
                '&:hover': { backgroundColor: appTheme.color12 },
                textTransform: 'none', marginRight: '10px',
            }}>
                 <img src={androidLogo} alt="androidLogo" style={{ width: '20px', height: '20px', marginRight: '3px' }} /> Download
            </Button>}
            <IconButton
            id="withdrawalDetails"
              size="large"
              aria-label="withdrawal details"
              color="inherit"
              component={NavLink}
              to="/withdrawDetails"
              label="withdrawDetails"
              value="withdrawDetails"
            >
              <Badge color="error">
                <AccountBalanceRoundedIcon />
              </Badge>
            </IconButton>
            <IconButton
            id="notification"
              size="large"
              aria-label="show notifications"
              color="inherit"
              component={NavLink}
              to="/notifications"
              label="notifications"
              value="notifications"
            >
              <Badge badgeContent={0} color="warning">
                <NotificationsNoneRoundedIcon />
              </Badge>
            </IconButton>
          </Box>
            </div>
          }
         {
          !showDiv && joyTour.status !=='OPEN' &&
          <div className="transitionDiv display-block-wallet"
          style={!isIntersecting ? mountedStyle : unmountedStyle} >
            <Box sx={{ display: 'flex', width:'100%',  justifyContent:'space-between', alignItems:'center', boxShadow:"0 0 10px rgba(0, 0, 0, 0.3)" }}>
          <Box sx={{display:'flex', alignItems:'center'}}>
          <MenuIcon sx={{cursor:'pointer', mr:1}} onClick={handleDrawerToggle}/>
            <Typography variant="h6" fontWeight={"bold"} display="block">
             <span style={{ color: appTheme.color6 }}>₹</span><span style={{ color: appTheme.color12 }}>{wallet_balance}</span>
            </Typography> 
          </Box>
          <Box sx={{display:'flex'}}>
            <Box
            sx={{textAlign:'center', textDecoration:'none', color:appTheme.color1, cursor:'pointer'}} 
            onClick={() => {
              navigate('/walletDeposit');
            }}>
                 <img
                  src={depositIcon}
                  width="60"
                  alt="logo"
                /> 
                <Typography variant="caption" display="flex" gutterBottom fontSize={11} sx={{mt:-2, justifyContent:'center'}}>
                 Deposit
                  </Typography>
            </Box>
            <Box 
            sx={{textAlign:'center', textDecoration:'none', color:appTheme.color1, cursor:'pointer', opacity:withdraw_status === 'off' ? 0.4 : 1}} 
            onClick={() => {  
              if(withdraw_status === 'off'){
                setSnackBarMessage(hold_withdrawal_remarks || 'Withdraw wallet on hold, we are under maintenance!');
                setOpenSnackbar(true);
              }else{
                navigate('/withdrawWallet')
              }
            }}>
                <img
                  src={withdrawIcon}
                  width="60"
                  alt="logo"
                />
                 <Typography variant="caption" display="flex" gutterBottom fontSize={11} sx={{mt:-2, justifyContent:'center'}}>
                 {withdraw_status === 'off' && <ConstructionOutlinedIcon sx={{fontSize:15}}/>} Withdraw
                  </Typography>
              </Box>
           
          </Box>
        </Box>
          </div>
          
         }
        </Toolbar>
      </AppBar>
      <Toolbar />

    </>
  );
};
const Header = React.memo(HeaderBar)
export default Header;
